export const cookiesSelector = {
  button: "accept-cookie-button",
};
